<template>
<div class="main">
  <div id="card" class="card">
    <h6 class="card-header">Suppliers</h6>
    <div class="card-body prog-container">
      <b-table responsive small ref="table" :items="items" :fields="fields">

        <template slot="actions" slot-scope="row">
          <b-button variant="info" size="sm" @click="updateRow(row.index)" class="mr-1" style="padding-left:10px;padding-right:10px">
            Update
          </b-button>
          <b-button variant="danger" size="sm" @click="showDeleteModal(row.index)" class="mr-1" style="padding-left:10px;padding-right:10px">
            Delete
          </b-button>
        </template>

      </b-table>
    </div>
  </div>

  <div v-show="update" id="card" class="card">
    <h6 class="card-header">Update Supplier</h6>
    <div class="card-body">
      <b-container>
        <b-row align-h="start">
          <b-col cols="3">
            <b-form-input class="input" v-model="selected.name" placeholder="Name:" disabled/>
          </b-col>
          <b-col cols="6">
            <b-form-input v-model="selected.contact" placeholder="Contact Info:"/>
          </b-col>
          <b-col>
            <div class="">
              <b-button variant="info" size="sm" @click="updateSupplier()" class="mr-1" style="padding-left:10px;padding-right:10px">
                Update
              </b-button>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container>
    </div>
  </div>

  <div id="card" class="card">
    <h6 class="card-header">Insert Supplier</h6>
    <div class="card-body">
      <b-container>
        <b-row align-h="start">
          <b-col cols="3">
            <b-form-input class="input" v-model="supplier.name" placeholder="Name:" />
          </b-col>
          <b-col cols="6">
            <b-form-input v-model="supplier.contact" placeholder="Contact Info:" />
          </b-col>
          <b-col>
            <div class="">
              <b-button variant="info" size="sm" @click="addSupplier()" class="mr-1">
                Add
              </b-button>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container>
    </div>
  </div>


  <div>
    <b-modal ref="my-modal" hide-footer hide-header title="Using Component Methods">
      <div class="d-block text-center">
          <p>Are you sure you want to delete this supplier?</p>
      </div>
      <div class="d-flex w-100 justify-content-center">
        <b-button size="sm" variant="outline-secondary" @click="toggleModal" style="margin-right:4%">Cancel</b-button>
        <b-button size="sm" variant="outline-danger" @click="deleteRow()" style>Proceed</b-button>
      </div>
    </b-modal>
  </div>

</div>
</template>
<script>
export default {
  created() {
    this.$overlay.show(this);
    this.$api.getSuppliers().then((response) => {
      if (response.status == 200) {
        this.items = response.data;
      }
      this.$overlay.hide();
    }).catch(error => {
      this.$overlay.hide();
    })
  },
  data: () => ({
    update:false,
    index:0,
    selected:{
      name: '',
      contact: ''
    },
    supplier: {
      name: '',
      contact: ''
    },
    fields: [
      {key:'name',label:"Name"},
      {key:'contact',label:'Contact Information'},
      {key:'actions',label:'Actions'}
    ],
    items: [

    ],
    deleteIndex:-1
  }),
  methods: {
    toggleModal() {
        this.$refs['my-modal'].toggle('#toggle-btn')
    },
    addSupplier() {
      if (this.supplier.name == '' || this.supplier.contact == '') {
                    this.$toasted.error('Information Missing').goAway(1200)
                    return;
                }
      if (this.supplier.name != '' && this.supplier.contact != '') {
        this.$overlay.show(this);
        this.$api.addSupplier(this.supplier).then((response) => {
          if (response.status == 202) {
            this.$toasted.success("Supplier added.").goAway(1200);
            this.items.push(this.supplier);
          }
          this.$overlay.hide();
          this.supplier = {
            name: '',
            contact: ''
          };
        }).catch(error => {
          this.$overlay.hide();
          if (error.response.status == 404) {
            this.$toasted.error("Supplier already exists.").goAway(1200);
          }
        });
      }
    },
    showDeleteModal(index){
      this.deleteIndex = index;
      this.toggleModal();
    },
    deleteRow(){
      this.$overlay.show(this);
      this.$api.deleteSupplier(this.items[this.deleteIndex]).then((response) => {
        if(response.status == 202){
          this.items.splice(this.deleteIndex,1);
          this.$toasted.success("Supplier deleted.").goAway(1200);
        }
        this.$overlay.hide();
      }).catch(error => {
        if(error.response.status == 406)
          this.$toasted.error("Cannot delete this supplier as its linked with inventory items").goAway(2000);
        else
          this.$toasted.error(error.response.data.message).goAway(1200);

        this.$overlay.hide();
      })
      this.toggleModal();
    },
    updateRow(index){
      this.update = true;
      this.index = index;
      this.selected.name = this.items[index].name;
      this.selected.contact = this.items[index].contact;
    },
    updateSupplier(){
      if (this.selected.contact == '') {
                    this.$toasted.error('Information Missing').goAway(1200)
                    return;
                }
      this.$overlay.show(this);
      this.$api.addSupplier(this.selected).then((response) => {
        if(response.status == 202){
          this.items[this.index] = this.selected;
          this.$toasted.success("Supplier Info updated.").goAway("1200");
        }
        this.$overlay.hide();
        this.update = false;
        this.$refs.table.refresh();
        this.selected = {
          name: '',
          contact: ''
        };
      }).catch(error => {

        this.$overlay.hide();
      })
    }
  }
}
</script>
<style lang="css" scoped>


.input{
  padding-left: 2%;
  padding-right: 5%;
  max-width: 300px;

}

.card-header{
  color: white;
  background-color:#2a2a2e;
}


button{
  padding-left: 8%;
  padding-right: 8%;
}

.main{
  width:100%;
  height: 100%;
}

.prog-container{
  max-height: 300px;
  overflow-y: auto;
}


.card-header{
  text-align: left;
}


</style>
